<template>
  <div
    ref="trigger"
    @mouseenter="showTooltip"
    @focus="showTooltip"
    @mouseleave="hideTooltip"
    @blur="hideTooltip"
    @click="displayModal"
  >
    <slot name="trigger" />
  </div>
  <teleport to="body">
    <Transition
      enter-active-class="duration-300 ease-out"
      enter-from-class="opacity-0"
      enter-to-class="opacity-100"
      leave-active-class="duration-200 ease-in"
      leave-from-class="opacity-100"
      leave-to-class="opacity-0"
    >
      <div
        ref="container"
        v-if="!props.disabled"
        v-show="showing"
        class="absolute z-20 inline-block rounded-lg border border-gray-200 bg-white py-2 px-3 text-sm text-gray-900 shadow-sm transition-opacity dark:bg-gray-700 dark:text-white"
        :class="tooltipClasses"
      >
        <div :class="props.width">
          <slot />
        </div>
      </div>
    </Transition>
  </teleport>

  <ModalInformation
    :show="modal && !props.disabled"
    @close="modal = false"
    title="Information"
  >
    <TextBase color="text-gray-600" size="text-sm" is="div">
      <slot />
    </TextBase>
  </ModalInformation>
</template>

<script setup>
import { computed, ref } from 'vue'
import { usePopper } from '../util/hooks/usePopper'
import ModalInformation from '../Overlays/Modals/ModalInformation.vue'
import TextBase from '../Text/TextBase.vue'

const props = defineProps({
  disabled: Boolean,
  font: {
    type: String,
    default: 'font-medium',
  },
  width: {
    type: String,
    default: 'max-w-xs',
  },
})

let [trigger, container, instance] = usePopper({
  placement: 'top',
  modifiers: [
    {
      name: 'offset',
      options: {
        offset: [0, 8],
      },
    },
  ],
})

const showing = ref(false)
const modal = ref(false)

function showTooltip() {
  showing.value = true
  instance.value.update()
}

function hideTooltip() {
  showing.value = false
}

function displayModal() {
  modal.value = true
}

const tooltipClasses = computed(() => [props.font].join(' '))
</script>
